module.exports = __webpack_public_path__ + "img/getbox@2x.5e29392d.png";